var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMindgrapherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1806 2434.33",
    style: {
      enableBackground: "new 0 0 1806 2434.33"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#FFB000;}\r\n\t.st2{fill:#FF8200;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1593.71,721.46L550.75,153.04l-28.02,10.04l-336.49,1441.6l3.42,12.4l613.14,678.59l26.29,2.58l766.31-530.79 l6.72-11.99V734.49L1593.71,721.46z M1545.4,754.03l-623.91,384.15L710.17,836.49l835.15-82.58L1545.4,754.03z M264.1,1542.94 l416.32-687.92l211.22,301.54L264.1,1542.94z M910.67,1183.72l123.07,175.7L285.56,1568.6L910.67,1183.72z M1530.79,724.11 L694.54,806.8L566.27,198.44L1530.79,724.11z M539.85,250.31l120.21,570.12l-412.3,681.28L539.85,250.31z M808.11,2250.36 l-573.58-634.8l801.6-224.12L808.11,2250.36z M847.04,2245.67l225.3-848.65l482.99,358.05L847.04,2245.67z M1565.34,1721.18 l-479.69-355.6l-23.21-26.18l-121.92-174.06l623.25-383.75l1.57,2.36V1721.18z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 829.46,
    cy: 2265.84,
    r: 104.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1583.73,
    cy: 1746.64,
    r: 104.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1583.73,
    cy: 736.85,
    r: 104.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 540.77,
    cy: 168.49,
    r: 104.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 679.25,
    cy: 842.3,
    r: 104.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1061.18,
    cy: 1372.53,
    r: 104.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 222.27,
    cy: 1606.46,
    r: 104.74
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMindgrapherIcon);
export default __webpack_public_path__ + "static/media/mindgrapher-icon.c97ff6fd.svg";
export { ForwardRef as ReactComponent };